var _mask, _path, _path2, _path3, _path4, _rect, _rect2, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_929_52255",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.691 22.9414C17.7022 22.9414 14.4688 26.1468 14.4688 30.101C19.6488 31.0269 21.4419 28.3726 21.691 26.9903C22.313 30.101 26.5058 30.4943 28.9132 30.101C28.9132 26.1468 25.6797 22.9414 21.691 22.9414Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4688 30.101H12.9688V31.3566L14.2048 31.5775L14.4688 30.101ZM28.9132 30.101L29.1551 31.5813L30.4132 31.3757V30.101H28.9132ZM21.691 26.9903L23.1618 26.6961C23.0206 25.9897 22.397 25.4834 21.6766 25.4903C20.9562 25.4972 20.3425 26.0153 20.2147 26.7243L21.691 26.9903ZM15.9688 30.101C15.9688 26.9876 18.5183 24.4414 21.691 24.4414V21.4414C16.8862 21.4414 12.9688 25.3061 12.9688 30.101H15.9688ZM21.691 24.4414C24.8636 24.4414 27.4132 26.9876 27.4132 30.101H30.4132C30.4132 25.3061 26.4958 21.4414 21.691 21.4414V24.4414ZM28.6713 28.6206C27.637 28.7896 26.2284 28.7804 25.0727 28.4257C23.9296 28.0748 23.3227 27.5005 23.1618 26.6961L20.2201 27.2844C20.6813 29.5907 22.4818 30.7685 24.1924 31.2936C25.8904 31.8148 27.782 31.8057 29.1551 31.5813L28.6713 28.6206ZM20.2147 26.7243C20.1624 27.015 19.8869 27.6577 19.1209 28.1475C18.383 28.6194 17.0438 29.0375 14.7327 28.6244L14.2048 31.5775C17.0738 32.0904 19.2212 31.6443 20.7371 30.6749C22.2249 29.7235 22.9705 28.3479 23.1672 27.2562L20.2147 26.7243Z",
    fill: "#68768B",
    mask: "url(#path-1-inside-1_929_52255)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2656 17.6538C11.2656 11.9094 15.9391 7.25 21.6864 7.25C27.4338 7.25 32.1073 11.9094 32.1073 17.6538V24.3292C32.1073 30.0844 27.4417 34.75 21.6864 34.75C15.9312 34.75 11.2656 30.0844 11.2656 24.3292V17.6538Z",
    stroke: "#68768B",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8984 9.75391H29.7932V8.25391H27.8984V9.75391ZM34.2489 14.2095V16.9488H35.7489V14.2095H34.2489ZM32.5325 20.1652C34.3089 20.1652 35.7489 18.7252 35.7489 16.9488H34.2489C34.2489 17.8967 33.4804 18.6652 32.5325 18.6652V20.1652ZM29.7932 9.75391C32.254 9.75391 34.2489 11.7488 34.2489 14.2095H35.7489C35.7489 10.9203 33.0824 8.25391 29.7932 8.25391V9.75391Z",
    fill: "#68768B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 9.75391H13.6804V8.25391H15.8125V9.75391ZM8.75154 14.6828V16.9488H7.25154V14.6828H8.75154ZM8.75154 16.9488C8.75154 17.8967 9.51998 18.6652 10.4679 18.6652V20.1652C8.69155 20.1652 7.25154 18.7252 7.25154 16.9488H8.75154ZM13.6804 9.75391C10.9583 9.75391 8.75154 11.9606 8.75154 14.6828H7.25154C7.25154 11.1322 10.1298 8.25391 13.6804 8.25391V9.75391Z",
    fill: "#68768B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.1875,
    y: 10.3672,
    width: 4.91475,
    height: 1.06098,
    rx: 0.530488,
    fill: "#68768B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.0234,
    y: 13.2227,
    width: 7.24621,
    height: 1.06098,
    rx: 0.530488,
    fill: "#68768B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8103 18.7963C19.8103 20.1921 18.6671 21.3348 17.243 21.3348C15.819 21.3348 14.6758 20.1921 14.6758 18.7963C14.6758 17.4005 15.819 16.2578 17.243 16.2578C18.6671 16.2578 19.8103 17.4005 19.8103 18.7963Z",
    stroke: "#68768B",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7048 18.7963C28.7048 20.1921 27.5616 21.3348 26.1376 21.3348C24.7135 21.3348 23.5703 20.1921 23.5703 18.7963C23.5703 17.4005 24.7135 16.2578 26.1376 16.2578C27.5616 16.2578 28.7048 17.4005 28.7048 18.7963Z",
    stroke: "#68768B",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8086 19.3723L32.3092 18.2695",
    stroke: "#68768B",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7656 19.3216L11.1336 18.1093",
    stroke: "#68768B",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2266 19.418H23.9181",
    stroke: "#68768B",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElder);
export default __webpack_public_path__ + "static/media/elder.9f74b25c6d93c784ebf9c372ca5d4c54.svg";
export { ForwardRef as ReactComponent };